import useCashbackProgram from '../../hooks/cashback/useCashbackProgram';
import useAuth from '../../hooks/global/useAuth';
import { useTranslation } from 'react-i18next';
import useAppMethods from '../../hooks/utility/useAppMethods';
import { ButtonTypes } from '../../services/exports/Interfaces';
import RewardIcon from '../../assets/logo/RewardIcon';
import useTheme from '../../hooks/ui/useTheme';
import useInitialData from '../../hooks/global/useInitialData';
import useScreenType from '../../hooks/utility/useScreenType';
import classNames from 'classnames';

interface Props {
  type: 1 | 2;
  className?: string;
}
export default function CashbackBalance({ type = 1, className }: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Cashback:CashbackBalance' });

  const { isLoggedIn } = useAuth();
  const { formatCurrency, toggleLoginModal } = useAppMethods();
  const { data } = useInitialData();
  const { company } = data;
  const { isDesktop } = useScreenType();
  const theme = useTheme();
  const { hasCashbackProgram, cashbackProgram, balance, formattedBalance, calculateMinAmountForExpectedCashback } =
    useCashbackProgram();

  const onLoginClick = () =>
    toggleLoginModal({
      openModal: true,
      onCloseRedirect: () => null,
    });

  const renderCashBack = (): JSX.Element | null => {
    switch (type) {
      case 2:
        return !isLoggedIn ? (
          <div
            className={classNames(
              'flex lg:items-center lg:h-[42px] h-fit cursor-pointer justify-between gap-sm lg:mx-none mx-md bg-brand-primary/25 dark:bg-brand-card rounded-lg px-md lg:py-2 py-sm',
              className,
            )}
            onClick={onLoginClick}
          >
            <div className="flex lg:items-center items-start gap-sm">
              <RewardIcon
                backgroundColor={theme.buttons[ButtonTypes.primary].background}
                color={theme.buttons[ButtonTypes.primary].text}
                className="w-[20px] h-[20px] shrink-0"
                fill
              />
              <h6 className="font-normal lg:text-sm text-xs">
                {t('points.label', {
                  company: company?.name,
                  reward: formatCurrency(5),
                  spend: formatCurrency(calculateMinAmountForExpectedCashback(5)),
                })}
              </h6>
            </div>
            <button className="flex items-center shrink-0 gap-sm h-fit bg-gray-500 dark:!bg-brand-button-primary-background/10 rounded-full px-xs py-[3px]">
              <h6 className="lg:text-sm text-xs">{isDesktop ? t('buttons.sign_in_sign_up') : t('buttons.sign_in')}</h6>
            </button>
          </div>
        ) : null;
      default:
        return (
          <div className="w-fit">
            {isLoggedIn ? (
              <h5>{t('my_points')}</h5>
            ) : (
              <div className="flex">
                <h5 className="my-auto">{t('loyalty_points')}</h5>
                <p className="my-auto text-xs ml-xs">{t('already_have_points')}</p>
                <button
                  onClick={onLoginClick}
                  className="text-brand-primary text-xs underline my-auto ml-2xs uppercase"
                >
                  {t('log_in')}
                </button>
              </div>
            )}
            <div className="mt-md rounded-lg shadow dark:shadow-none py-md px-lg">
              <p className="text-xs">
                {t('description', { percentage: cashbackProgram.percentage, amount: formatCurrency(1) })}
              </p>
              <hr className="my-md" />
              {isLoggedIn ? (
                <h6>
                  {balance} p{balance > 0 && ` (${formattedBalance})`}
                </h6>
              ) : (
                <h6>500 p = {formatCurrency(5)}</h6>
              )}
            </div>
          </div>
        );
    }
  };

  return hasCashbackProgram && renderCashBack();
}
